@let itemsValue = items();
@let expandedById = expandedBy();
@if (itemsValue.length) {
  <div [@actions-nav]="expandedById ? 'expanded' : 'collapsed'" class="expanded-container">
    <div class="expanded-header" [hidden]="!expandedById">
      <span class="label">
        {{ (expandedByItem()?.label ?? '') | translate }}
      </span>
      <sxw-svg-icon
        class="icon"
        name="cross"
        fillColor="var(--p-primary-600)"
        strokeColor="var(--p-primary-600)"
        (click)="expandedBy.set(undefined)"></sxw-svg-icon>
    </div>
    @for (item of itemsValue; track item.id) {
      <div [hidden]="item.id !== expandedById">
        <ng-container *ngTemplateOutlet="item.template"></ng-container>
      </div>
    }
  </div>

  <ul class="items-container">
    @for (item of itemsValue; track item.id; let idx = $index) {
      <li class="item" [pTooltip]="item?.tooltip ?? '' | translate" (click)="expandedBy.set(item.id)" [class.isActive]="expandedById === item.id">
        <div class="item-icon-wrapper">
          @if (item.icon) {
            <sxw-svg-icon
              width="15"
              height="15"
              [name]="item.icon"
              [fillColor]="expandedById === item.id ? 'white' : '#7f56d9'"
              [strokeColor]="expandedById === item.id ? 'white' : '#7f56d9'"></sxw-svg-icon>
          }
          @if (item.badge && item.badge > 0) {
            <span class="item-badge">{{ item.badge > 99 ? '99+' : item.badge }}</span>
          }
        </div>
      </li>
    }
  </ul>
}
